import React, { Fragment } from 'react'
import Icon from './icon'
import { Button } from './button'
import Header from './header'
import { List } from './list'
import { Field } from './field'
import { ChromePicker, SketchPicker, SwatchesPicker, CompactPicker } from 'react-color'
import './color.css'

/**
 * Component
 */
const ColorCircle = ({ name, hex, rgb, onClick, onRemove }) => {
    const style = hex ? { backgroundColor: `#${hex}` } : null
    const empty = hex ? '' : 'empty'
    return (
        <div className={`color-circle ${empty}`} style={style} onClick={onClick}>
            {rgb ? <span className="color-name">{name}</span> : null}
        </div>
    )
}

/**
 * Component
 */
const ColorLine = ({ code, name, hex, onSelect }) => {
    const style = hex ? { backgroundColor: `#${hex}` } : null
    const empty = hex ? '' : 'empty'
    const select = () => {
        if (onSelect) onSelect({ code, name, hex })
    }
    return (
        <div className={`color-line ${empty}`} onClick={select}>
            <div className="color-square" style={style}></div>
            <span className="color-name">{name}</span>
            <span className="color-code">{code}</span>
        </div>
    )
}

/**
 * Component
 */
class ColorSelector extends React.Component {

    static defaultProps = {
        editable: false,
        colors: []
    }

    state = {
        editable: this.props.editable,
        colors: this.props.colors,
        picker: false,
        selected: null,
    }

    onAdd = () => {
        const colors = this.state.colors.slice()
        colors.unshift({ name: null })
        this.setState({ colors })
    }

    onRemove = () => {
        const { onChange } = this.props
        const colors = this.state.colors.slice()
        colors.splice(this.state.selected, 1)
        if (onChange) onChange(colors)
        this.setState({ colors, picker: false })
    }

    onToggle = (selected) => {
        if (this.state.editable) {
            const picker = !this.state.picker
            this.setState({ picker, selected })
        }
    }

    onChange = (color) => {
        const { onChange } = this.props
        const colors = this.state.colors.slice()
        colors[this.state.selected] = color
        if (onChange) onChange(colors)
        this.setState({ colors, picker: false })
    }

    render() {
        return (
            <div className={`color-selector`}>
                {this.state.editable ? <Icon icon="add_circle_outline" small clickable action={this.onAdd} /> : ''}
                {this.state.colors.map((color, index) => (<ColorCircle {...color} onClick={() => this.onToggle(index)} />))}
                {this.state.picker ? (
                    <dialog>
                        <ColorPicker onClose={this.onToggle} onOK={this.onChange} onRemove={() => this.onRemove()} {...this.props} />
                    </dialog>
                ) : ''}
            </div>
        )
    }
}

/**
 * Component
 */
class ColorPicker extends React.Component {

    state = {
        display: false,
        color: null,
        colorBook: "pantoneSolidCoatedV3M2",
        search: []
    }

    onChange = (id, value) => {
        this.setState({ [id]: value })
    }

    onToggle = () => {
        const colorBook = this.state.colorBook === "pantoneSolidCoatedV3M2" ? "pantoneSolidUncoatedV3M2" : "pantoneSolidCoatedV3M2"
        this.setState({ colorBook })
    }

    getPantone(code) {
        const { pantoneService } = this.props
        return pantoneService ? pantoneService.byCode(code) : []
    }

    getClosestColors = (hex) => {
        const { pantoneService } = this.props
        return pantoneService ? pantoneService.byHex(hex) : []
    }

    onBasic = (code, hex) => {
        const color = { name: code, code, hex }
        this.setState({ color })
    }

    onSelect = async (pick) => {

        //const pantone = await this.getClosestColor(pick.hex, this.state.colorBook)
        //const color = pantone.data.getClosestColors[0]
        //this.setState({ color })

        const closest = await this.getClosestColors(pick.hex, this.state.colorBook)
        if (closest.length > 0) {
            const color = closest[0]
            console.log('onSelect', color)
            this.setState({ color })
        }

    }

    onCustom = async (code) => {
        if (code.length > 2) {
            const search = await this.getPantone(code)
            this.setState({ search })
        }
    }

    onClose = () => {
        this.props.onClose()
    }

    canOK = () => {
        return this.state.color != null
    }

    onOK = () => {
        const { onOK } = this.props
        console.log('onOK', this.state.color, onOK)
        if (onOK) onOK(this.state.color)
    }

    renderCMYKPicker = () => {
        const cyan = '00FFFF' //{ r: 0, g: 255, b: 255 }
        const magenta = 'FF00FF' //{ r: 255, g: 0, b: 255 }
        const yellow = 'FFFF00' //{ r: 255, g: 255, b: 0 }
        const black = '000' //{ r: 0, g: 0, b: 0 }
        return (
            <div className="basics">
                <ColorCircle hex={cyan} onClick={() => this.onBasic('Cyan', cyan)} />
                <ColorCircle hex={magenta} onClick={() => this.onBasic('Magenta', magenta)} />
                <ColorCircle hex={yellow} onClick={() => this.onBasic('Amarillo', yellow)} />
                <ColorCircle hex={black} onClick={() => this.onBasic('Negro', black)} />
            </div>
        )
    }

    renderPantonePicker = () => {
        return (
            <Fragment>
                <CompactPicker onChange={this.onSelect} />
                <Field id="color" icon="search" type='text' onChange={(id, value) => { this.onCustom(value) }} />
                <List className="search-list" items={this.state.search} onEmpty={() => <div>...</div>}>
                    <ColorLine onSelect={this.onBasic} />
                </List>
            </Fragment>
        )
    }

    render() {
        const { pantone = true, CMYK = true } = this.props
        const color = this.state.color
        const hex = color ? `#${color.hex}` : ''
        const selection = color ? color.code : '....'
        return (
            <div className="color-picker">
                <Header icon={{ icon: 'color_lens' }} primary>
                    <Icon icon="close" action={this.onClose} />
                </Header>
                <div className="color-selection" style={{ backgroundColor: hex }}>
                    {selection}
                </div>

                {CMYK ? this.renderCMYKPicker() : ''}

                {pantone ? this.renderPantonePicker() : ''}

                <footer>
                    <Button label="ELIMINAR" action={this.props.onRemove} />
                    <Button label="OK" action={this.onOK} disabled={!this.canOK()} />
                </footer>
            </div>
        )
    }
}

export { ColorPicker, ColorSelector, ColorCircle }


// WEBPACK FOOTER //
// ./src/lib/components/color.js